var UPGRADE_TO_CONSULTANT_KEY = 'become-consultant';
var UPGRADE_TO_BRAND_PARTNER_KEY = 'upgrade-to-brand-partner';
var filterMenuItems = function filterMenuItems(items, isDesktop) {
  return isDesktop ? items : items.filter(function (x) {
    var _x$url, _x$url2;
    return !((_x$url = x.url) !== null && _x$url !== void 0 && _x$url.includes(UPGRADE_TO_CONSULTANT_KEY)) && !((_x$url2 = x.url) !== null && _x$url2 !== void 0 && _x$url2.includes(UPGRADE_TO_BRAND_PARTNER_KEY));
  });
};
var findUrl = function findUrl(menuItems, key) {
  var _menuItems$find$url, _menuItems$find;
  return (_menuItems$find$url = (_menuItems$find = menuItems.find(function (x) {
    var _x$url3;
    return (_x$url3 = x.url) === null || _x$url3 === void 0 ? void 0 : _x$url3.includes(key);
  })) === null || _menuItems$find === void 0 ? void 0 : _menuItems$find.url) !== null && _menuItems$find$url !== void 0 ? _menuItems$find$url : '';
};
export var useMenuItemsFilter = function useMenuItemsFilter(items, isDesktop) {
  return {
    filteredItems: filterMenuItems(items, isDesktop),
    upgradeToConsultantUrl: findUrl(items, UPGRADE_TO_CONSULTANT_KEY),
    upgradeToBrandPartnerUrl: findUrl(items, UPGRADE_TO_BRAND_PARTNER_KEY)
  };
};